import { Link } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

export const NavCard = ({ link, icon, title, description, size, noArrow, colortype}) => {
	let cardClassName = 'card card--nav'
	if (size === 'sm') {
		cardClassName += ' card--nav--sm'
	}
	if (colortype === 'green') {
    	cardClassName += ' card--nav--green'
    } else if (colortype === 'purple') {
        cardClassName += ' card--nav--purple'
    } else if (colortype === 'yellow') {
        cardClassName += ' card--nav--yellow'
    }

	return (
		<Link className={cardClassName} to={link}>
			<div className="card__body">
				{size !== 'sm' && <GatsbyImage className='card__body__image' image={getImage(icon.localFile)} alt={icon.alternativeText} />}
				<div className="card__body__description">
					<div className="description__text">
						<b>{title}</b>
						<ReactMarkdown children={description} rehypePlugins={[rehypeRaw]} />
					</div>
					{!noArrow && <i className="icon-arrow-right" />}
				</div>
			</div>
		</Link>
	)
}
